require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/fn/object/set-prototype-of.js
// module id = 1991
// module chunks = 2